<script setup>
import BasicBodyPage from '#common/components/BasicBodyPage.vue'
import { defineAsyncComponent } from 'vue'

const Error404 = defineAsyncComponent(
  () => import('#common/components/Error/Error404'),
)

const route = useRoute()
const { data: pageData } = await useFetch(`/api/wagtail/pages/`, {
  query: { slug: route.params.slug_wagtail },
})

const pageId = computed(() => pageData.value?.items[0]?.id)
const type = computed(() => pageData.value?.items[0]?.meta?.type)
const error = computed(() => pageId.value === undefined)

const classForPage = computed(() => {
  if (type.value === 'wa_wagtail.JotFormBasicPage') return ''
  return 'generic'
})
</script>

<template>
  <div v-if="error" class="nuxt-error">
    <Error404 />
  </div>
  <section v-else :class="classForPage">
    <BasicBodyPage :page-id="pageId" />
  </section>
</template>
